import { mapRecordToArray } from '@deity-io/di-data-basics';
import { Box, Checkbox, Icon } from '@deity-io/portal-ui';
import type { FC } from 'react';
import type { IContainerChildrenProps } from 'utils';
import RequestParamsEditCell from './EditGridCell';
import type { IEditGridColumnsProps } from './EditGridColumn';

const EditGridRow: FC<
  {
    columns: IEditGridColumnsProps;
    rowIndex: number;
    row: Record<string, string | number | undefined> | undefined;
    onToggleEdit?: (index: number, type: string, editOn: boolean) => void;
    onToggleChecked?: (index: number, checked: boolean) => void;
    onChange?: (index: number, column: string, value: string) => void;
    onDelete?: (index: number) => void;
    editColumn?: string;
    checked?: boolean;
    error?: boolean;
    options?: { hasCheckBox?: boolean };
  } & IContainerChildrenProps
> = ({
  columns,
  rowIndex,
  onToggleEdit,
  onToggleChecked,
  onChange,
  onDelete,
  editColumn,
  options,
  checked,
  error,
  row
}) => (
  <Box style={{ display: 'contents' }} className="hover-row">
    <Box
      alignItems="center"
      key={`_row_${rowIndex}_checkbox`}
      style={{ backgroundColor: error ? 'orange' : undefined }}
    >
      {options?.hasCheckBox && onToggleChecked && row && (
        <Checkbox
          checked={checked}
          onChange={(e, value) => {
            if (onToggleChecked) {
              onToggleChecked(rowIndex, value);
            }
          }}
        />
      )}
    </Box>
    {mapRecordToArray(columns, (column, key) => (
      <RequestParamsEditCell
        column={column}
        value={row ? row[column.key || key] : undefined}
        key={`_row_key_${key}`}
        inEdit={editColumn === key}
        onToggleEdit={
          !column.locked
            ? editOn => {
                if (onToggleEdit) {
                  onToggleEdit(rowIndex, key, editOn);
                }
              }
            : undefined
        }
        onChange={value => {
          if (onChange) {
            onChange(rowIndex, key, value);
          }
        }}
      />
    ))}

    <Box>
      {onDelete && (
        <Icon
          icon="close"
          onClick={() => {
            if (onDelete) {
              onDelete(rowIndex);
            }
          }}
        />
      )}
    </Box>
  </Box>
);

export default EditGridRow;
